module.exports = __webpack_public_path__ + "img/logo.0ada3d95.png";